import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

const options = {
  confirmButtonColor: '#48BB78',
  cancelButtonColor: '#F56565',
};

Vue.use(VueSweetalert2, options);

const TOAST_CONFIG = {
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 10000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Vue.swal.stopTimer);
    toast.addEventListener('mouseleave', Vue.swal.resumeTimer);
  },
};

const Toast = Vue.swal.mixin(TOAST_CONFIG);

Vue.prototype.$toast = Toast;

export default Toast;
